export const PROJECT_CONFIGS = {
  svicon: {
    logo: '/svicon-logo.png',
    backgroundType: 'image',
    background: '/handicraft.png',
    titleColor: '#707070',
    showCarousel: false,
    developerText: 'Developed by Quote In Code Technology Pvt. ltd.',
  },
  aagam: {
    logo: '/aagam-logo.png',
    backgroundType: 'image',
    background: '/aagam.png',
    titleColor: '#005900',
    showCarousel: false,
    // developerText: 'Developed by Aagam.com',
  },
} as const;

export type ProjectType = keyof typeof PROJECT_CONFIGS;
